import * as yup from "yup";

export const StudentSituationFormValidation = yup.object().shape({
    idStudent: yup.string().required("O código do estudante é obrigatório."),
    studentCode: yup.string().required("O código do estudante é obrigatório."),
    description: yup
        .string()
        .required("A descrição da situação é obrigatória.")
        .min(10, "A descrição deve ter pelo menos 10 caracteres."),
    problem: yup
        .string()
        .max(500, "O problema deve ter no máximo 500 caracteres."),
    soluction: yup
        .string()
        .max(500, "A solução deve ter no máximo 500 caracteres."),
    reason: yup
        .string()
        // .max(500, "O motivo deve ter no máximo 500 caracteres.")
        ,
    status: yup.boolean().default(true),
    isResolved: yup.boolean().default(false),
});
